import PropTypes from 'prop-types';
import { ThemeProvider } from 'emotion-theming';
import { css } from '@emotion/core';
import SearchBox from '@veeva/corgix/searchbox';
import mobileContentWidthCSS from '../../constants/mobileContentWidthCSS';

const theme = {
    textInputHeight: '3.3333rem',
};

const HomeTitleMobile = ({ onChange, onClear, onSearch, searchPlaceholder, searchTerm, title }) => {
    return (
        <>
            {title}
            <ThemeProvider theme={theme}>
                <div
                    css={css`
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 0.6666rem;
                    `}
                >
                    <SearchBox
                        css={css`
                            border-radius: 8px;
                            ${mobileContentWidthCSS}
                        `}
                        value={searchTerm}
                        onChange={onChange}
                        onSearch={onSearch}
                        onClear={onClear}
                        placeholder={searchPlaceholder}
                        size="lg"
                    />
                </div>
            </ThemeProvider>
        </>
    );
};

HomeTitleMobile.propTypes = {
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    onSearch: PropTypes.func,
    searchPlaceholder: PropTypes.string,
    searchTerm: PropTypes.string,
    title: PropTypes.element,
};

export default HomeTitleMobile;
